var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccess48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.9999999,0.49999993 C10.5735931,0.49999993 0.49999993,10.5735931 0.49999993,22.9999999 C0.49999993,35.4264069 10.5735931,45.4999999 22.9999999,45.4999999 C35.4264069,45.4999999 45.4999999,35.4264069 45.4999999,22.9999999 C45.4999999,10.5735931 35.4264069,0.49999993 22.9999999,0.49999993 Z M35.735,17.885 L20.885,32.735 C20.3222952,33.2983312 19.5587277,33.61486 18.7625,33.61486 C17.9662722,33.61486 17.2027048,33.2983312 16.64,32.735 L14.51,30.605 L10.265,26.36 C9.50670374,25.6017038 9.21055536,24.496463 9.48811104,23.4606111 C9.76566672,22.4247592 10.5747591,21.6156668 11.610611,21.3381111 C12.6464629,21.0605554 13.7517038,21.3567038 14.51,22.115 L18.755,26.36 L31.49,13.64 C32.6622244,12.4677756 34.5627756,12.4677756 35.735,13.64 C36.9072244,14.8122244 36.9072244,16.7127756 35.735,17.885 L35.735,17.885 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CBA-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconSuccess48"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/32/iconStatusApprove32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -1.000000)",
    id: "\\uD83C\\uDFA8-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Colour/brand/green",
    fill: "#5AE18C",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess48);
export default __webpack_public_path__ + "static/media/iconSuccess48.9d6b6e7e58ff0df4c45d94133d8f6597.svg";
export { ForwardRef as ReactComponent };